import { Box } from "@chakra-ui/react"

const ActiveDot = ({
  top = "0px",
  right = "0px",
  left = "initial",
}: {
  top?: string
  right?: string
  left?: string
}) => (
  <Box
    w={3}
    h={3}
    bgColor='#EA4335'
    borderRadius='100%'
    position='absolute'
    top={top}
    right={right}
    left={left}
  />
)

export default ActiveDot
